<template>
  <div class="wlx-site-manager-wrapper-1">
    <div class="yk-wrap-fixed clearfix">
      <div class="ad-school-manager-head fr">
        <el-form :inline="true" size="small">
          <div class="d-search-form-news">
            <el-form-item>
              <el-input v-model="schoolName" placeholder="请输入单位名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="schoolProvince" placeholder="请选择省份" clearable>
                <el-option
                  v-for="item in privinceData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="seaIsPost" placeholder="审核情况" clearable>
                <el-option label="审核中" value="0"></el-option>
                <el-option label="通过" value="1"></el-option>
                <el-option label="未通过" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="isUploadSignName" clearable placeholder="是否上传签名">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              <el-button type="primary" icon="el-icon-chat-line-round" @click="smsSendAll">短信发送</el-button>
              <a class="export-button-a" style="color:#fff" :href="downLoadUrl">申报资料下载</a>
              <el-button type="primary" icon="el-icon-chat-line-round" @click="openLog" class="export-button-a">审核日志查看</el-button>
              <!-- <el-button type="primary" @click.native="getSchoolFiles">申报资料下载</el-button> -->
              <a :href="excelUpload" download class="a-download-class">
                <el-button type="primary">导出</el-button>
              </a>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div style="padding-left:30px;">
        <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="schoolName" label="单位名称"></el-table-column>
          <el-table-column prop="responsibleProvince" label="省份" width="100"></el-table-column>
          <el-table-column prop="responsibleCity" label="城市" width="100"></el-table-column>
          <el-table-column prop="contactsName" label="联系人姓名"></el-table-column>
          <el-table-column prop="contactsPhone" label="联系人联系方式"></el-table-column>
          <el-table-column prop="createDisplayName" label="申请人"></el-table-column>
          <el-table-column prop="createUserName" label="申请账号"></el-table-column>
          <el-table-column prop="IsLecturer" label="是否通过">
            <template slot-scope="scope">
              <span :title="'审核意见:'+scope.row.auditOpinion" v-if="scope.row.isPost==0">审核中</span>
              <span :title="'审核意见:'+scope.row.auditOpinion" v-if="scope.row.isPost==1">通过</span>
              <span :title="'审核意见:'+scope.row.auditOpinion" v-if="scope.row.isPost==2">未通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="dateCreated" label="申请时间"></el-table-column>
          <el-table-column prop="leadName" label="负责人姓名" ></el-table-column>
          <el-table-column prop="leadNameUrl" label="负责人签名">
            <template slot-scope="scope">
              <img height="80" width="80" :src="scope.row.leadNameUrl" v-if="scope.row.leadNameUrl" @click="seeLeadNameUrl(scope.row.leadNameUrl)"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="详情" placement="top-start">
                <!-- <el-button>上左</el-button> -->
                <el-button
                  size="mini"
                  class="wl-icon-yanjing"
                  @click="view(scope.row.id)"
                  type="primary"
                ></el-button>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" content="审核" placement="top-start">
                <el-button
                  size="mini"
                  type="danger"
                  icon="wl-icon-shenhe"
                  @click="openAppLiDialog(scope.row.id,scope.row.isPost,scope.row.auditOpinion)"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="短信发送" placement="top-start">
                <el-button size="mini" type="primary" icon="el-icon-chat-line-round" @click="smsSend(scope.row.createUserName)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="news-page-con">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="50%"
      :before-close="handleClose"
    >

     <el-form label-width="200px">
      <el-form-item label="审核意见：">
        <el-input type="textarea" :rows="5" v-model="auditOpinion" placeholder="请输入审核意见"></el-input>
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="isPost">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="2">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="postAssessmentApply">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 签名图片放大 -->
    <el-dialog
      title="签名查看"
      :visible.sync="LeadNameUrlVisible"
      width="50%"
      top="3%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <img width="80%" :src="LeadNameUrl" style="margin-left:10%;"/>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="LeadNameUrlVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 日志 -->
    <el-dialog
      title="审核日志查看"
      :visible.sync="logVisible"
      width="80%"
      top="3%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">

      <el-form :inline="true" size="small">
        <div class="d-search-form-news">
          <el-form-item>
            <el-select v-model="siteId" filterable placeholder="请选择单位" style="width:300px" clearable>
              <el-option
                v-for="item in siteList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="objectLogs" filterable placeholder="请选择审核状态" style="width:200px" clearable>
              <el-option label="审核通过" value="审核通过"> </el-option>
              <el-option label="审核未通过" value="审核未通过"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchLog">搜索</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div style="padding-left:30px;">
        <el-table ref="multipleeeeTable" :data="logList" tooltip-effect="dark">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="dateCreated" label="审核时间" width="160"></el-table-column>
          <el-table-column prop="objectName" label="审核站点" width="240"></el-table-column>
          <el-table-column prop="objectLogs" label="审核日志" width="100"></el-table-column>
          <el-table-column prop="logData" label="审核意见"></el-table-column>
        </el-table>
      </div>
      <div class="news-page-con">
        <el-pagination
          background
          @size-change="logHandleSizeChange"
          @current-change="logOnPageChangeHandler"
          :current-page="logPageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="logPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="logTotal"
          v-show="logTotal>0"
        ></el-pagination>
      </div>


      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="logVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      schoolName: "", // 搜索条件
      isUploadSignName:"",
      dialogVisible: false,
      isPost: 0, // 是否通过
      id: "",
      privinceData: "",
      schoolProvince: "",
      downLoadUrl: "/api/XOrg/DownloadFile/DownSchoolFile",
      fileUrlList: [],
      seaIsPost:'',
      //签名照片放大
      LeadNameUrlVisible:false,
      LeadNameUrl:"",
      // 群发
      ids:[],
      auditOpinion:'',
      // 日志列表
      objectLogs:"",
      logVisible:false,
      logList: [],
      logTotal: 0,
      logPageSize: 10,
      logPageIndex: 1,
      siteList:[],
      siteId:""
    };
  },
  props:{
    certificateId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getSessionStorage();
    this.school = this.$store.state.auth.userName;
    this.getSchoolList();
    this.getProvinceData();
  },
  computed: {
    export(params) {
      return axios({
        headers: {
          "Content-Type": "application/json"
        },
        responseType: "blob", //一定要写
        method: "post",
        url: "/export",
        data: {
          head: {},
          body: {
            data: params
          }
        }
      });
    },
    excelUpload() {
      return (
        "/api/XOrg/AssessmentApplySys/exportExcel?province=" +
        this.schoolProvince +
        "&schoolName=" +
        this.schoolName+
        "&certificateId=" + this.certificateId
      );
    }
  },
  methods: {
    openLog(){
      this.getLogs();
      this.getSiteList();
      this.logVisible = true;
    },
    getSiteList(){
      this.$http
        .post("/api/XOrg/AssessmentApply/getSiteList")
        .then(res => {
          if (res.code > 0) {
            this.siteList = res.list;
          } else {
            this.$message.warning(res.msg);
            return;
          }
        });
    },
    searchLog(){
      this.logPageIndex = 1;
      this.getLogs();
    },
    getLogs(){
      var that = this;
      this.$http
        .post("/api/XOrg/AssessmentApplySys/getSiteLogs", {
          objectId:this.siteId,
          objectLogs:this.objectLogs,
          page: that.logPageIndex,
          pageSize: that.logPageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            that.logList = rst.list;
            that.logTotal = rst.pagination.totalCount;
            that.logPageSize = rst.pagination.pageSize;
            that.logPageIndex = rst.pagination.pageIndex;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    logOnPageChangeHandler(page) {
      this.logPageIndex = page;
      this.getLogs();
    },
    logHandleSizeChange(val) {
      this.logPageIndex = 1;
      this.logPageSize = val;
      this.getLogs();
    },


    handleSelectionChange(rows){
      var ids = [];
      rows.forEach(ele=>{
        ids.push(ele.id);
      });
      this.ids = ids;
    },
     seeLeadNameUrl(url){
      this.LeadNameUrlVisible = true;
      this.LeadNameUrl = url;
    },
    encryption: function (str) {
        let Base64 = require("js-base64").Base64;
        return Base64.encode(str);
    },
    smsSendAll(){
      var that = this;
      if(this.ids.length == 0){
        that.$message.warning("请选择通知学校");
        return;
      }
      let str_ = Date.parse(new Date()) / 1000;
      let str = this.encryption(str_);
      let str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      str1 = s1 + "s" + s2;
      
      this.$confirm('此操作将给已选学校发送一条签名上传的提醒短信,是否发送', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         this.$http
          .post("/api/XOrg/AssessmentApplySys/smsSendAll",{
            str:str,
            str1:str1,
            ids:this.ids
          })
          .then(res => {
            if (res.code > 0) {
              // that.ids = [];
              that.$refs.multipleeeeTable.clearSelection();
              that.$message.success(res.msg);
            }else{
              that.$message.warning(res.msg);
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消发送'
        });  
      });        
    },
    smsSend(mobile){
      let str_ = Date.parse(new Date()) / 1000;
      let str = this.encryption(str_);
      let str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      str1 = s1 + "s" + s2;
      var that = this;
      this.$confirm('此操作将给用户发送一条签名上传的提醒短信,是否发送', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         this.$http
          .post("/api/XOrg/AssessmentApplySys/smsSend",{
            mobile:mobile,
            str:str,
            str1:str1
          })
          .then(res => {
            if (res.code > 0) {
              that.$message.success(res.msg);
            }else{
              that.$message.warning(res.msg);
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消发送'
        });          
      });
    },
    getProvinceData() {
      this.$http
        .post("/api/XOrg/Questionnaire/getAllProvinceList")
        .then(res => {
          if (res.code > 0) {
            this.privinceData = res.province;
          }
        });
    },
    getSchoolList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssessmentApplySys/getAssessmentApplyList", {
          schoolName: this.schoolName,
          schoolPrivince: this.schoolProvince,
          seaIsPost:this.seaIsPost,
          isUploadSignName:this.isUploadSignName,
          certificateId:this.certificateId,
          page: this.pageIndex,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            that.list = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;

            // 参数存储本地缓存
            sessionStorage.setItem("wlx_assessmentApply_schoolName",that.schoolName);
            sessionStorage.setItem("wlx_assessmentApply_schoolProvince",that.schoolProvince);
            sessionStorage.setItem("wlx_assessmentApply_seaIsPost",that.seaIsPost);
            sessionStorage.setItem("wlx_assessmentApply_isUploadSignName",that.isUploadSignName);
            sessionStorage.setItem("wlx_assessmentApply_pageIndex",that.pageIndex);
            sessionStorage.setItem("wlx_assessmentApplye_pageSize",that.pageSize);
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    // 获取网页缓存信息
    getSessionStorage(){
      // 获取网页缓存信息
      var schoolName = sessionStorage.getItem("wlx_assessmentApply_schoolName");
      var schoolProvince = sessionStorage.getItem("wlx_assessmentApply_schoolProvince");
      var seaIsPost = sessionStorage.getItem("wlx_assessmentApply_seaIsPost");
      var isUploadSignName = sessionStorage.getItem("wlx_assessmentApply_isUploadSignName");
      var pageIndex = sessionStorage.getItem("wlx_assessmentApply_pageIndex");
      var pageSize = sessionStorage.getItem("wlx_assessmentApplye_pageSize");
     
      if(schoolName != null&& schoolName != undefined&&schoolName!="null"){
        this.schoolName = schoolName;
      }
      if(schoolProvince != null&& schoolProvince != undefined&&schoolProvince!="null"){
        this.schoolProvince = schoolProvince;
      }
      if(seaIsPost != null&& seaIsPost != undefined&&seaIsPost!="null"){
        this.seaIsPost = seaIsPost;
      }
      if(isUploadSignName != null&& isUploadSignName != undefined&&isUploadSignName!="null"){
        this.isUploadSignName = isUploadSignName;
      }
      if(pageIndex != null && pageIndex != undefined){
        this.pageIndex = Number(pageIndex);
      }
      if(pageSize != null && pageSize!= undefined){
        this.pageSize = Number(pageSize);
      }
    },
    onPageChangeHandler(page) {
      this.pageIndex = page;
      this.getSchoolList();
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.getSchoolList();
    },
    openAppLiDialog(id, isPost,auditOpinion) {
      this.id = id;
      this.isPost = isPost;
      this.dialogVisible = true;
      this.auditOpinion=auditOpinion
    },
    search() {
      this.pageIndex = 1;
      this.getSchoolList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    postAssessmentApply() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssessmentApplySys/postAssessmentApply", {
          id: that.id,
          IsPost: that.isPost,
          auditOpinion:that.auditOpinion
        })
        .then(rst => {
          if (rst.code == 1) {
            that.$message.success(rst.msg);
            that.dialogVisible = false;
            that.getSchoolList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    // 详情
    view(id) {
      this.$router.push({
        name: "examTableDetail",
        params: {
          tableId: id
        }
      });
    },
    getSchoolFiles() {
      var that = this;
      this.$http.post("/api/XOrg/DownloadFile/getSchoolFiles").then(res => {
        if (res.code > 0) {
          this.fileUrlList = res.fileUrlList;
          res.fileUrlList.forEach(element => {
            that.handleExport({ zipName: "das", urlArray: element });
          });
        }
      });
    },
    DowLoadFile(url, savepath) {
      var that = this;
      this.$http
        .post("/api/XOrg/HttpManager/DowLoadFile", {
          url: url,
          savepath: savepath
        })
        .then(res => {
          if (res.code > 0) {
            this.fileUrlList = res.fileUrlList;
            res.fileUrlList.forEach(element => {
              that.handleExport({ zipName: "das", urlArray: element });
            });
          }
        });
    },
    handleExport(params) {
      // const params = {};
      this.export(params).then(res => {
        console.log(res.data);
        const blob = new Blob([res.data]); //处理文档流
        const fileName = "excel.xlsx";
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      });
    }
  }
};
</script>


<style lang='scss'>
.wlx-site-manager-wrapper-1 {
  .news-page-con {
    padding: 20px 0;
    text-align: center;
  }
  .d-search-form-news {
    margin: 13px 0px 0 0;
  }
  .ad-school-manager-head {
    width: calc(100% - 240px);

    text-align: right;
  }
  .export-button-a {
    color: #fff;
    background: #409eff;
    padding: 8px 15px;
    border-radius: 4px;
    margin: 0 10px;
  }
}
</style>
